import { useState } from 'react';

import { HoverTooltip } from '../HoverTooltip';
import { cn } from '~/utils/cnTailwind';

type Props = {
    text: string;
    tooltipBeforeCopyText: string;
    tooltipAfterCopyText: string;
    className?: string;
    dataTestId?: string;
    tooltipOffsetX?: number;
    tooltipOffsetY?: number;
    children?: React.ReactNode;
    renderButton?: (props: {
        onClick: () => void;
        onMouseLeave: () => void;
        className?: string;
        'data-testid'?: string;
        tooltipText: string;
    }) => React.ReactNode;
    showTooltip?: boolean;
};

export const TextWithCopy = ({
    children,
    className,
    dataTestId,
    renderButton,
    showTooltip = true,
    text,
    tooltipAfterCopyText,
    tooltipBeforeCopyText,
    tooltipOffsetX,
    tooltipOffsetY,
}: Props) => {
    const [tooltipTextState, setTooltipTextState] = useState<string>(tooltipBeforeCopyText);

    const handleClick = () => {
        navigator.clipboard.writeText(text);
        setTooltipTextState(tooltipAfterCopyText);
    };

    const handleMouseLeave = () => {
        if (tooltipTextState === tooltipBeforeCopyText) {
            return;
        }
        setTooltipTextState(tooltipBeforeCopyText);
    };

    const domProps = {
        className: cn('cursor-pointer', className),
        'data-testid': dataTestId,
        onClick: handleClick,
        onMouseLeave: handleMouseLeave,
    };

    const buttonProps = {
        ...domProps,
        tooltipText: tooltipTextState,
    };

    const buttonContent = renderButton ? renderButton(buttonProps) : <div {...domProps}>{children ?? text}</div>;

    if (!showTooltip) {
        return <>{buttonContent}</>;
    }

    return (
        <HoverTooltip
            tooltipText={tooltipTextState}
            tooltipOffsetX={tooltipOffsetX}
            tooltipOffsetY={tooltipOffsetY}
            wrapperClassName="inline"
        >
            {buttonContent}
        </HoverTooltip>
    );
};
